import { numbersKeys, PASSWORD_LENGTH } from '../kidsLeavePopup.constant';
import { t } from '../../../i18n';

export const getPasswordString = password => {
  if (!password || password.split('').length !== PASSWORD_LENGTH) return '';

  const passwordParts = password.split('').map(key => t(`global.numbers.${numbersKeys[+key]}`).toUpperCase());

  return passwordParts.join(' - ');
};
